import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AppProvider } from "./context/AppContext";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/store";
import "./index.css";
import "./i18n";
import { Buffer } from "buffer";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
window.Buffer = Buffer;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <AppProvider>
      <ErrorBoundary componentName="Root" logProps={true}>
        <App />
      </ErrorBoundary>
    </AppProvider>
  </Provider>
);

reportWebVitals();
